import Category from "../../../components/category/category";

import { behavior } from "../../../constants/behavior";

export default function Behavior() {
    return (
        <section id="Behavior">
            <Category>Behavior</Category>
            {behavior.map((val, i) => (
                <p key={ i } className="article-information">{val}</p>
            ))}
        </section>
    );
};